export default __webpack_public_path__ + "static/HeroSectionLeft_it-e980f3d79ed0d3bc0557febc48cf47bd.png";